module.exports = __webpack_public_path__ + "static/media/bugbounty.d357b3c3.png";